import React, { useState } from 'react';
import Box from '../Box/Box';
import CloseIcon from '../../images/icons/close.svg';
import { rem } from 'polished';
import { css } from 'styled-components';

export default function BookingFormModal({ onClose, children }) {
    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            right="0"
            bottom="0"
            zIndex={9000}
            display="flex"
            justifyContent="center"
            alignItems="center"
            my="0 !important"
        >
            <Box
                onClick={() => {
                    onClose?.();
                }}
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                backgroundColor="rgba(0, 0, 0, 0.4)"
            />

            {children}
        </Box>
    );
}

BookingFormModal.FrameContainer = function FrameContainer({
    onClose,
    ...props
}) {
    return (
        <Box
            position="relative"
            width="100%"
            maxWidth="1280px"
            height="70svb"
            px={rem(20)}
        >
            <Box
                display="block"
                as={CloseIcon}
                size={rem(24)}
                color="neutral.white"
                // onClick={onClose}
                position="absolute"
                zIndex={100}
                top={-35}
                right={rem(25)}
                pointerEvents="none"
            />
            <Box
                width="100%"
                maxWidth="100%"
                height="100%"
                borderRadius="sm"
                overflow="hidden"
                userSelect="none"
                position="relative"
                css={css`
                    & > * {
                        height: 100%;
                        width: 100%;
                    }
                `}
                {...props}
            />
        </Box>
    );
};
